import {createReducer, on} from '@ngrx/store';
import * as searchAction from '@app/marketplace/products/state/product-search/search-actions';
import * as fromSearch from './search-state'
import { ProductProviderEnum } from '@app/marketplace/core/enum/productProvider';
const initialState: fromSearch.State = {
  searhTerm:"",
  provider:ProductProviderEnum.Internal
};
export const reducer = createReducer(
  initialState,
  on(searchAction.KeyPressInSearch, (state, {term}) => {
    return {...state, searhTerm:term};
  }),
  on(searchAction.SearchProducts, (state) => {
    return {...state};
  }),
  on(searchAction.SearchProductsSuccess, (state, {term}) => {
    return {...state, searhTerm:term};
  }),
  on(searchAction.SearchProductsFailure, (state) => {
    return {...state, searhTerm:""};
  }),
  on(searchAction.SearchProductsError, (state) => {
    return {...state, searhTerm:""};
  }),
  on(searchAction.CancelSearchRequest, (state) => {
    return {...state, searhTerm:""};
  }),
  on(searchAction.CancelSearchRequest, (state) => {
    return {...state, searhTerm:""};
  }),
  on(searchAction.DeleteSearchTerm, (state) => {
    return {...state, searhTerm:""};
  }),
  on(searchAction.SetProvider, (state, {provider}) => {
    return {...state, provider};
  }),
);

